// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Descriptif administratif acheteur-BC, structure/layout IDENTIQUE a MS.
   Copie ISOLEE des regles .opms__* de la page MS (SuiviOperationMSV2.css), renommees .bcadm-*
   pour que BC ne depende PAS de la feuille MS. Grille 12 colonnes, sous-sections titrees,
   champs alignes sur .input-inactif, compteur de caracteres. */

.bcadm-desc__sous-section {
  margin-bottom: 2.4rem;
}
.bcadm-desc__sous-section:last-child {
  margin-bottom: 0;
}
.bcadm-desc__sous-section-titre {
  font-size: 2rem;
  font-weight: 700;
  color: #000;
  margin: 0 0 1.2rem;
  padding-bottom: 0.6rem;
}

/* Grille 12 colonnes (fidele au PDF : rangees de 3 / 4 / 2 champs via les spans inline). */
.bcadm-desc__grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.2rem 2rem;
  align-items: start;
}
@media screen and (max-width: 900px) {
  .bcadm-desc__grid > * {
    grid-column: 1 / -1 !important;
  }
}

/* Champs editables ET lecture seule a la meme taille (meme box-model). */
.bcadm-desc__grid .form-group input,
.bcadm-desc__grid .form-group textarea,
.bcadm-desc__grid .form-group select,
.bcadm-desc__grid .form-group .input-inactif {
  width: 100%;
  box-sizing: border-box;
  padding: 1.2rem;
  border-radius: 10px;
  font: inherit;
  line-height: 1.4;
}
.bcadm-desc__grid .form-group input,
.bcadm-desc__grid .form-group select,
.bcadm-desc__grid .form-group .input-inactif {
  min-height: 4.6rem;
}
.bcadm-desc__grid .form-group input,
.bcadm-desc__grid .form-group textarea,
.bcadm-desc__grid .form-group select {
  border: 1px solid #e5e7eb;
  color: #2c3948;
  background: #fff;
}
/* Read-only : on NE surcharge PAS la couleur (comme MS) -> elle reste #6b7280 (global .input-inactif). */
.bcadm-desc__grid .form-group .input-inactif {
  border: 1px solid transparent;
}

/* Compteur de caracteres sous un champ saisi. */
.bcadm-char-count {
  display: block;
  text-align: right;
  font-size: 1.1rem;
  color: #6b7280;
  margin-top: 0.3rem;
}

/* Descriptif technique : les 3 champs doc dans la grille 12 colonnes (span 4). */
.bcadm-desc__doc-technique {
  margin-bottom: 1.6rem;
}

/* Cahier des charges : textarea plein + rendu lecture seule, aligne sur MS. */
.bcadm-besoin-textarea {
  width: 100%;
  min-height: 200px;
  resize: vertical;
  font: inherit;
  line-height: 1.4;
  padding: 1.2rem;
  box-sizing: border-box;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  color: #2c3948;
}
.bcadm-besoin-readonly {
  min-height: 80px;
  white-space: pre-wrap;
  padding: 1.2rem;
  border-radius: 10px;
}

/* Autocomplete d'adresse (IGN) : dropdown positionne sous le champ. Autonome (le module acheteur
   ne charge pas de feuille externe pour ces classes). */
.bcadm-desc__grid .autocomplete-container {
  position: relative;
}
.bcadm-desc__grid .autocomplete-list {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  z-index: 20;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 100%;
  max-width: 60rem;
  max-height: 32rem;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}
.bcadm-desc__grid .autocomplete-list li {
  padding: 1rem 1.2rem;
  font-size: 1.3rem;
  line-height: 1.35;
  white-space: normal;
  cursor: pointer;
}
.bcadm-desc__grid .autocomplete-list li:hover {
  background: #f3f4f6;
}

/* Padding des sections identique a MS (.opms__consultation .section-pliable-content { padding: 4rem }).
   Scope a la consultation BC (root .consultation-bc, commun acheteur + presta) : n'impacte pas les
   autres SectionPliable de l'app. */
.consultation-bc .section-pliable-content {
  padding: 4rem;
}

/* Documentation technique : les 3 champs partagent une rangee, et leurs libelles n'ont pas la meme
   longueur (« Liste des pièces éventuelles composant la documentation technique » tient sur 2 lignes).
   La grille est en \`align-items: start\` : chaque cellule se cale en haut et prend la hauteur de son
   contenu, donc un libelle plus long descend SON champ et casse l'alignement de la rangee.

   On etire les cellules a la hauteur de la rangee et on pousse le champ en bas : les champs
   s'alignent quelle que soit la hauteur des libelles — y compris si l'un passe un jour sur 3 lignes.
   Preferable a un \`min-height\` sur le libelle, qui figerait un nombre de lignes.
   Pendant prestataire : \`.bcc-desc__grid--doc\` dans CommandeConsultation.css. */
.bcadm-desc__doc-technique .bcadm-desc__grid {
  align-items: stretch;
}
.bcadm-desc__doc-technique .bcadm-desc__grid .form-group {
  display: flex;
  flex-direction: column;
}
.bcadm-desc__doc-technique .bcadm-desc__grid .form-group textarea,
.bcadm-desc__doc-technique .bcadm-desc__grid .form-group .input-inactif {
  margin-top: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationBCV2/components/DescriptifAdministratifBC.css"],"names":[],"mappings":"AAAA;;;+DAG+D;;AAE/D;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,2FAA2F;AAC3F;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA,yEAAyE;AACzE;;;;EAIE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA,yGAAyG;AACzG;EACE,6BAA6B;AAC/B;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iFAAiF;AACjF;EACE,qBAAqB;AACvB;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;wDACwD;AACxD;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;;oCAEoC;AACpC;EACE,aAAa;AACf;;AAEA;;;;;;;;gFAQgF;AAChF;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,gBAAgB;AAClB","sourcesContent":["/* Descriptif administratif acheteur-BC, structure/layout IDENTIQUE a MS.\n   Copie ISOLEE des regles .opms__* de la page MS (SuiviOperationMSV2.css), renommees .bcadm-*\n   pour que BC ne depende PAS de la feuille MS. Grille 12 colonnes, sous-sections titrees,\n   champs alignes sur .input-inactif, compteur de caracteres. */\n\n.bcadm-desc__sous-section {\n  margin-bottom: 2.4rem;\n}\n.bcadm-desc__sous-section:last-child {\n  margin-bottom: 0;\n}\n.bcadm-desc__sous-section-titre {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #000;\n  margin: 0 0 1.2rem;\n  padding-bottom: 0.6rem;\n}\n\n/* Grille 12 colonnes (fidele au PDF : rangees de 3 / 4 / 2 champs via les spans inline). */\n.bcadm-desc__grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 1.2rem 2rem;\n  align-items: start;\n}\n@media screen and (max-width: 900px) {\n  .bcadm-desc__grid > * {\n    grid-column: 1 / -1 !important;\n  }\n}\n\n/* Champs editables ET lecture seule a la meme taille (meme box-model). */\n.bcadm-desc__grid .form-group input,\n.bcadm-desc__grid .form-group textarea,\n.bcadm-desc__grid .form-group select,\n.bcadm-desc__grid .form-group .input-inactif {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1.2rem;\n  border-radius: 10px;\n  font: inherit;\n  line-height: 1.4;\n}\n.bcadm-desc__grid .form-group input,\n.bcadm-desc__grid .form-group select,\n.bcadm-desc__grid .form-group .input-inactif {\n  min-height: 4.6rem;\n}\n.bcadm-desc__grid .form-group input,\n.bcadm-desc__grid .form-group textarea,\n.bcadm-desc__grid .form-group select {\n  border: 1px solid #e5e7eb;\n  color: #2c3948;\n  background: #fff;\n}\n/* Read-only : on NE surcharge PAS la couleur (comme MS) -> elle reste #6b7280 (global .input-inactif). */\n.bcadm-desc__grid .form-group .input-inactif {\n  border: 1px solid transparent;\n}\n\n/* Compteur de caracteres sous un champ saisi. */\n.bcadm-char-count {\n  display: block;\n  text-align: right;\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin-top: 0.3rem;\n}\n\n/* Descriptif technique : les 3 champs doc dans la grille 12 colonnes (span 4). */\n.bcadm-desc__doc-technique {\n  margin-bottom: 1.6rem;\n}\n\n/* Cahier des charges : textarea plein + rendu lecture seule, aligne sur MS. */\n.bcadm-besoin-textarea {\n  width: 100%;\n  min-height: 200px;\n  resize: vertical;\n  font: inherit;\n  line-height: 1.4;\n  padding: 1.2rem;\n  box-sizing: border-box;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  color: #2c3948;\n}\n.bcadm-besoin-readonly {\n  min-height: 80px;\n  white-space: pre-wrap;\n  padding: 1.2rem;\n  border-radius: 10px;\n}\n\n/* Autocomplete d'adresse (IGN) : dropdown positionne sous le champ. Autonome (le module acheteur\n   ne charge pas de feuille externe pour ces classes). */\n.bcadm-desc__grid .autocomplete-container {\n  position: relative;\n}\n.bcadm-desc__grid .autocomplete-list {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  z-index: 20;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  min-width: 100%;\n  max-width: 60rem;\n  max-height: 32rem;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n}\n.bcadm-desc__grid .autocomplete-list li {\n  padding: 1rem 1.2rem;\n  font-size: 1.3rem;\n  line-height: 1.35;\n  white-space: normal;\n  cursor: pointer;\n}\n.bcadm-desc__grid .autocomplete-list li:hover {\n  background: #f3f4f6;\n}\n\n/* Padding des sections identique a MS (.opms__consultation .section-pliable-content { padding: 4rem }).\n   Scope a la consultation BC (root .consultation-bc, commun acheteur + presta) : n'impacte pas les\n   autres SectionPliable de l'app. */\n.consultation-bc .section-pliable-content {\n  padding: 4rem;\n}\n\n/* Documentation technique : les 3 champs partagent une rangee, et leurs libelles n'ont pas la meme\n   longueur (« Liste des pièces éventuelles composant la documentation technique » tient sur 2 lignes).\n   La grille est en `align-items: start` : chaque cellule se cale en haut et prend la hauteur de son\n   contenu, donc un libelle plus long descend SON champ et casse l'alignement de la rangee.\n\n   On etire les cellules a la hauteur de la rangee et on pousse le champ en bas : les champs\n   s'alignent quelle que soit la hauteur des libelles — y compris si l'un passe un jour sur 3 lignes.\n   Preferable a un `min-height` sur le libelle, qui figerait un nombre de lignes.\n   Pendant prestataire : `.bcc-desc__grid--doc` dans CommandeConsultation.css. */\n.bcadm-desc__doc-technique .bcadm-desc__grid {\n  align-items: stretch;\n}\n.bcadm-desc__doc-technique .bcadm-desc__grid .form-group {\n  display: flex;\n  flex-direction: column;\n}\n.bcadm-desc__doc-technique .bcadm-desc__grid .form-group textarea,\n.bcadm-desc__doc-technique .bcadm-desc__grid .form-group .input-inactif {\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
